import { shopifyGql, ShopifyGqlUserErrors } from '../shopify_client/graphql'
import { ICart } from '../shopify_client/types'
import { cartFragment } from './fragments'

interface IRemoveFromCartArgs {
  cartID: string
  lineItemIDS: string[]
}

export async function removeFromCart({ cartID, lineItemIDS }: IRemoveFromCartArgs): Promise<ICart> {
  const cartLinesRemoveInput = {
    cartId: cartID,
    lineIds: lineItemIDS
  }

  const { data, errors } = await shopifyGql<ICartLinesRemoveData>(
    cartLinesRemoveMutation,
    cartLinesRemoveInput
  )

  if (errors.length > 0) { throw new AggregateError(errors, 'removeFromCart.cartLinesRemove') }

  return data.cartLinesRemove.cart
}

interface ICartLinesRemoveData {
  cartLinesRemove: {
    cart: {
      __typename: 'Cart'
    } & ICart
  } & ShopifyGqlUserErrors
}

const cartLinesRemoveMutation = `
mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      ...CartFragment
    }
    userErrors {
      field
      message
    }
  }
}
${cartFragment}
`
